import { plusAccessTerms } from "consts/urls";

const smartkarmaPlus = {
  id: "smartkarma-plus",
  title: "Smartkarma Plus",
  subtitle: "For Private Investors",
  linkedPlan: () => import("./smartkarmaPro"),
  linkedPlanLinkText: "Professional/Licensed Investors are not eligible",
  linkedPlanLink: "View Professional Investor Plans Instead »",
  style: "success",
  options: [
    {
      id: 1,
      title: "Annual Plan",
      priceScope: "year",
      priceScopeInMonth: 12,
      price: 599.99,
      stripePlan: "investor-plus-yearly",
      tooltip: "Save 20%",
    },
    {
      id: 2,
      title: "Monthly Plan",
      priceScope: "month",
      priceScopeInMonth: 1,
      price: 59.99,
      stripePlan: "investor-plus-monthly-limited-offer",
    },
  ],
  allowCoupon: true,
  features: [
    {
      title: "Extensive Access",
      enabled: true,
    },
    {
      title: "Actionable Ideas",
      enabled: true,
    },
    {
      title: "Breaking News",
      enabled: true,
    },
    {
      title: "Financial Data",
      enabled: true,
    },
    {
      title: "Webinars",
      enabled: true,
    },
    {
      title: "Daily Briefing",
      enabled: true,
    },
    {
      title: "Desktop and Mobile Access",
      enabled: true,
    },
  ],
  learnMoreLink: "https://www.smartkarma.com/home/private-investor-solutions/",
  buttonText: "Subscribe Now",
  agreement: (
    <>
      I have read and accepted the{" "}
      <a
        className="text-jade"
        href={plusAccessTerms}
        target="_blank"
        rel="noreferrer"
      >
        Smartkarma Plus Access Terms
      </a>
    </>
  ),
  contactSale: <></>,
};

export default smartkarmaPlus;
